import {
  GET_FIRMWARE_DATA,
  GET_FIRMWARE_TYPE_DROPDOWN,
  SET_FIRMWARE_DATA,
  UPDATE_FIRMWARE_DATA_STATUS,
} from "../actions/devicesModalTypes";
import { GET_DEVICES } from "../actions/types";

const initialState = {
  DevicesList: [],
  firmwareList: [],
  firmwareTypeDropdown: [],
  setFirmware: [],
  updateFirmwareStatus: [],
};

const ManageDevicesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DEVICES:
      return {
        ...state,
        DevicesList: payload,
      };
    default:
      return state;
  }
};
const devicesModalTacReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_FIRMWARE_DATA:
      return {
        ...state,
        firmwareList: payload,
      };
    case GET_FIRMWARE_TYPE_DROPDOWN:
      return {
        ...state,
        firmwareTypeDropdown: payload,
      };
    case SET_FIRMWARE_DATA:
      return {
        ...state,
        setFirmware: payload,
      };
    case UPDATE_FIRMWARE_DATA_STATUS:
      return {
        ...state,
        updateFirmwareStatus: payload,
      };
    default:
      return state;
  }
};

export { ManageDevicesReducer, devicesModalTacReducer };
